export function formatCurrency(amount, currency = "USD") {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `$${Number(amount).toFixed(2)}`;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatDate(iso) {
  if (!iso) return "—";
  const opts = { month: "short", day: "2-digit", year: "numeric" };
  // Calendar dates (YYYY-MM-DD) carry no time: format them as-is, never via local-time conversion.
  const m = DATE_ONLY.exec(String(iso));
  if (m) {
    const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    return d.toLocaleDateString("en-US", { ...opts, timeZone: "UTC" });
  }
  return new Date(iso).toLocaleDateString("en-US", opts);
}

export function timeAgo(iso) {
  if (!iso) return "never";
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function erpLabel(id) {
  if (id === "quickbooks") return "QuickBooks";
  if (id === "netsuite") return "NetSuite";
  if (id === "freshbooks") return "FreshBooks";
  if (id === "odoo") return "Odoo";
  return id;
}
